import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { IntakePill } from '../shell/IntakePill';
import { cardSx, type PillTone, wf } from '../shell/tokens';

/** Status copy and content are supplied by the owner; this view never advances the journey. */
export function IntakeJourneyStatus({
  title,
  statusLabel,
  children,
  action,
  tone = 'slate',
}: {
  title: string;
  statusLabel: string;
  children: ReactNode;
  action?: ReactNode;
  /** Pill colour: indigo = ours, amber = needs you, green = done, slate = not started. */
  tone?: PillTone;
}) {
  return (
    <Box sx={{ ...cardSx, padding: { xs: '22px 20px', md: '26px 28px' } }}>
      <Box>
        <IntakePill tone={tone} label={statusLabel} />
      </Box>
      <Typography
        component="h2"
        sx={{
          mt: '14px',
          fontSize: 19,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          color: wf.ink,
        }}
      >
        {title}
      </Typography>
      <Stack
        spacing={1}
        sx={{
          mt: '8px',
          maxWidth: 620,
          fontSize: 14,
          color: '#52526a',
          lineHeight: 1.65,
          '& .MuiTypography-root': { fontSize: 14, lineHeight: 1.65 },
        }}
      >
        {children}
      </Stack>
      {action && <Box sx={{ mt: '20px' }}>{action}</Box>}
    </Box>
  );
}
